// extracted by mini-css-extract-plugin
export default {"category":"style_category__LfBL7","image":"style_image__B-xsD","title":"style_title__uNSVD","text":"style_text__ypE2K"};